module.exports = __webpack_public_path__ + "img/sanyizhongong.42c51ea0.png";